import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function RolesWithResponsibilities({ otherRoles = [] }) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      id="other-roles-with-responsibilities"
      className="other-roles"
      sx={{
        p: { xs: 2, md: 3 },

        borderRadius: "39px",
        background: "#F3FBFF",
        height: "100%",
      }}
    >
      {otherRoles.length > 0 ? (
        otherRoles.map((item, index) => {
          const panelId = `panel-${index}`;
          return (
            <Accordion
              key={index}
              expanded={expanded === panelId}
              onChange={handleChange(panelId)}
              sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ mb: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {item.role}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {item.responsibilities && item.responsibilities.length > 0 ? (
                  <ul style={{ margin: 0, paddingLeft: 18 }}>
                    {item.responsibilities.map((resp, i) => (
                      <li key={i} style={{ fontSize: 13 }}>
                        {resp}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Typography variant="body2">
                    Description coming soon.
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })
      ) : (
        <Typography align="center" color="text.secondary">
          No other roles found.
        </Typography>
      )}
    </Box>
  );
}

export default RolesWithResponsibilities;
